export const BackgroundImage = () => import('../../../../components/BackgroundImage.vue' /* webpackChunkName: "components/background-image" */).then(c => wrapFunctional(c.default || c))
export const DidYouKnow = () => import('../../../../components/DidYouKnow.vue' /* webpackChunkName: "components/did-you-know" */).then(c => wrapFunctional(c.default || c))
export const HomeIntro = () => import('../../../../components/HomeIntro.vue' /* webpackChunkName: "components/home-intro" */).then(c => wrapFunctional(c.default || c))
export const RadialProgress = () => import('../../../../components/RadialProgress.vue' /* webpackChunkName: "components/radial-progress" */).then(c => wrapFunctional(c.default || c))
export const TopNav = () => import('../../../../components/TopNav.vue' /* webpackChunkName: "components/top-nav" */).then(c => wrapFunctional(c.default || c))
export const QuestionsCheckboxQuestion = () => import('../../../../components/questions/CheckboxQuestion.vue' /* webpackChunkName: "components/questions-checkbox-question" */).then(c => wrapFunctional(c.default || c))
export const QuestionsQuestionLabel = () => import('../../../../components/questions/QuestionLabel.vue' /* webpackChunkName: "components/questions-question-label" */).then(c => wrapFunctional(c.default || c))
export const QuestionsSliderQuestion = () => import('../../../../components/questions/SliderQuestion.vue' /* webpackChunkName: "components/questions-slider-question" */).then(c => wrapFunctional(c.default || c))
export const QuestionsToggleQuestion = () => import('../../../../components/questions/ToggleQuestion.vue' /* webpackChunkName: "components/questions-toggle-question" */).then(c => wrapFunctional(c.default || c))
export const ReportsGreenReport = () => import('../../../../components/reports/GreenReport.vue' /* webpackChunkName: "components/reports-green-report" */).then(c => wrapFunctional(c.default || c))
export const ReportsMindsetReport = () => import('../../../../components/reports/MindsetReport.vue' /* webpackChunkName: "components/reports-mindset-report" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
